<template>

<div class="container-fluid">
    <div class="row">
        <div class="col">
            <!-- native file input for file click -->
            <label 
                ref="drop"
                class="kt-upload form-control text-center p-5"
                @dragenter="dragEnter"
                @dragover="dragOver"
                @dragleave="dragLeave"
                @drop="dragDrop"
            >
                <span>Drag &amp; Drop your files or <u>Browse</u></span>
                <input
                    :id="props.id"
                    ref="upload"
                    class="kt-upload"
                    type="file"
                    @change="change"
                    :multiple="props.multiple"
                />
            </label>
        </div>
    </div>
</div>

</template>

<script setup>

import { ref, onMounted } from "vue";

const upload = ref(null);
const drop = ref(null);

const props = defineProps({
    id: 
    {
        type: String,
        default() 
        {
            return "upload-" + (Math.random() + "").substring(2);
        }
    },
    multiple: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits([
    "process"
]);

const dragEnter = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "#e1e1e1";
};

const dragOver = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "#e1e1e1";
};

const dragLeave = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "transparent";
};

const dragDrop = async (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "transparent";
    
    let files = [];
    
    // Check for Outlook email drag attempt (browser security prevents direct access)
    const isOutlookEmail = e.dataTransfer.types.includes('multimaillistmessagerows');
    
    // Modern API - supports file drag-and-drop
    if (e.dataTransfer.items) {
        const items = [...e.dataTransfer.items];
        
        for (let i = 0; i <items.length; i++) {
            const item = items[i];
            
            // Try to get file from item
            const file = item.getAsFile();
            
            if (file) {
                files.push(file);
            }
        }
    } else {
        // Fallback for older browsers - use legacy files API
        files = [...e.dataTransfer.files];
    }
    
    // Process files if we have any
    if (files.length > 0) {
        emits("process", files);
    } else if (isOutlookEmail) {
        // Show helpful message for Outlook email limitation
        alert("To attach Outlook emails:\n\n1. Drag the email to your Desktop first (saves as .msg file)\n2. Then drag the .msg file here\n\nOR\n\nRight-click the email → Save As → then upload the saved file\n\n(Browser security prevents direct email drag-and-drop)");
    }
};

const change = (e) =>
{
    if (upload.value.files.length)
    {
        emits("process", upload.value.files);
    }
};

onMounted(() =>
{
    // ... nothing   
});

</script>

<style scoped>

.kt-upload {
    border: 1px dotted #dedede;

}

.kt-upload input {
    position: absolute;
    visibility: hidden;
}
    

</style>